import { Component, Inject } from '@angular/core';
import { CommonService } from '@services/app.common.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { RoleAccessService } from '@services/role.access.service';
import { SSOType, CommonEnum } from '../_shared/_enums/Common';
import { DynamicScriptLoaderService } from '@services/dynamicScriptLoaderService';
declare var gtag: Function;


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    standalone: false
})
export class LoginComponent {
  user = {
    userName: '',
    password: ''
  }
  public validate: boolean = true;
  public loading: boolean = false;
  public baseUrl: string = "";
  public ssoConfig;
  public ssoType = SSOType;
  public commonEnum = CommonEnum;

  //public loginButtonTex = this.common.loginButtonText; //'Log in'
  constructor(private router: Router, public common: CommonService, public authService: AuthenticationService, http: HttpClient, @Inject('BASE_URL') baseUrl: string, public roleService: RoleAccessService, public dynamicScripts: DynamicScriptLoaderService) {
    this.baseUrl = baseUrl;
    this.ssoConfig = this.common.ssoConfig;
    if (this.router.url !== '/Login1' && this.router.url != '/Login1#ath') {
      if (this.ssoConfig != undefined) {
        if (this.ssoConfig.SingleSignOn == CommonEnum.Yes && this.ssoConfig.SingleSignOn_Type == SSOType.Microsoft && this.ssoConfig.ForceSingleSignIn_Microsoft == CommonEnum.Y) {
          this.SSOLogin();
        }
        else if (this.ssoConfig.SingleSignOn_Type == SSOType.Cas) {
          this.CASLogin();
        }
      }
    }
  }
  ngOnInit() {
    this.loadGoogleAnalytics();
  }
  public Login() {
    //this.common.NavigateToRoute("Home");
    //this.common.Loader.show();
    debugger;
    this.loading = true;
    this.common.loginButtonText ='Signing in...Please wait'
    if (this.Validate())
      this.authService.login(this.user.userName, this.user.password);
    else 
      return false;
  }

  public Validate() {
    if (this.user.userName && this.user.password)
      return true;
    else { this.validate = false; return false; }
  }

  public redirectToUrl() {
    ;
    window.open(this.baseUrl + this.common.ApiUrls.ForgotPassword.ForgotPasswordURl, '_blank');
  }

  public GoToDesktop() {
    window.open(this.common.desktopUrl);
  }
  public SSOLogin() {
    window.location.href = this.common.ApiUrls.Login.ApiSSOLogin;
    return false;
  }
  public CASLogin() {
    window.location.href = this.common.ApiUrls.Login.CASLogin;
    return false;
  }

  public loadGoogleAnalytics() {
    try {

      this.dynamicScripts.load('gaTag').then(data => {
        const gaScript = document.createElement('script');
        gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-142400835-1', {
      'custom_map': { 'dimension1': 'client' }
    });
      `;
        document.head.appendChild(gaScript);

        var settings = this.common.getSettings();
        var clientSetting = settings.ClientSetting;
        let clientName = 'jtdemo';
        if (clientSetting != null && clientSetting != "" && clientSetting.ClientName != "") {
          clientName = clientSetting.ClientName;
        }
        gtag('event', 'any_event_name', { 'client': clientName });

      });
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }
}
